import { FOLLOW_SUGGESTION, LOADING, IDLE, SUCCEEDED, FAILED } from '../constants';
import { populateSuggestedUserConnections } from './suggestedUserConnections';
import parseActivityAndTrail from '../utils/track_trail_formatters';
import { getOptions, getFeed } from '../../../utils/requests/community_requests';
import { formatFeedOptions, PUBLIC } from '../utils/blazes_helper';

export const SET_FEED_OPTIONS = 'SET_FEED_OPTIONS';
export const UPDATE_ACTIVE_FEED = 'UPDATE_ACTIVE_FEED';
export const UPDATE_ACTIVE_FEED_KEY = 'UPDATE_ACTIVE_FEED_KEY';

export const updateActiveFeedKey = payload => {
  return {
    type: UPDATE_ACTIVE_FEED_KEY,
    payload
  };
};

export const parseSuggestedUserConnections = sections => {
  return dispatch => {
    const follows = sections.find(s => s.section_type === FOLLOW_SUGGESTION);
    if (follows && follows.suggestions) {
      dispatch(populateSuggestedUserConnections(follows.suggestions));
    }
  };
};

export const getFeedOptions = (feedParam = PUBLIC) => {
  return (dispatch, getState) => {
    return getOptions(12345)
      .then(resp => {
        // TODO: CMTY-276, if there is no feedParam here, we should take a hint from the server
        dispatch({ type: SET_FEED_OPTIONS, payload: { feedOptions: formatFeedOptions(resp.feeds), activeFeedKey: feedParam } });
      })
      .catch(err => {
        console.error('error loading feed options', err);
      });
  };
};

export const SET_REQUEST_STATE = 'SET_REQUEST_STATE';
export const setRequestState = payload => {
  return {
    type: SET_REQUEST_STATE,
    payload
  };
};

export const getActiveFeed = () => {
  return (dispatch, getState) => {
    const { activeFeedKey, feedOptions } = getState().feeds;
    if (!activeFeedKey || !feedOptions) return;
    dispatch(setRequestState(LOADING));
    const {
      links: {
        start: { href }
      }
    } = feedOptions.find(fo => fo.name === activeFeedKey);

    return getFeed(href)
      .then(resp => {
        dispatch(parseSuggestedUserConnections(resp.sections));
        dispatch({ type: UPDATE_ACTIVE_FEED, payload: parseActivityAndTrail(resp.sections) });
        dispatch(setRequestState(SUCCEEDED));
      })
      .catch(err => {
        dispatch(setRequestState(FAILED));
        console.error('error loading active feed', err);
      });
  };
};

export const initialCommunityFeedState = {
  activeFeedKey: null,
  feedOptions: [],
  feeds: [],
  requestState: IDLE
};

export default function feeds(state = initialCommunityFeedState, action) {
  switch (action.type) {
    case SET_FEED_OPTIONS:
      return {
        ...state,
        feedOptions: action.payload.feedOptions,
        activeFeedKey: action.payload.activeFeedKey,
        feeds: action.payload.feedOptions.map(feed => {
          return { key: feed.name, activities: [] };
        })
      };
    case UPDATE_ACTIVE_FEED:
      return {
        ...state,
        feeds: state.feeds.map(feed => {
          if (state.activeFeedKey === feed.key) {
            return { ...feed, activities: [...feed.activities, ...action.payload] };
          }

          return feed;
        })
      };
    case UPDATE_ACTIVE_FEED_KEY:
      return {
        ...state,
        activeFeedKey: action.payload
      };
    case SET_REQUEST_STATE:
      return {
        ...state,
        requestState: action.payload
      };
    default:
      return state;
  }
}
